import { CONFIG } from '../../../config'
import {
  parseToMysqlFormat,
  parseToMysqlFormatWithTime00,
  parseToMysqlFormatWithTime23,
} from '../../util/date.service'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/ordem-coleta`
const DOCS_BASE_URL = `${CONFIG[ENVIROMENT]['DOCS_END_POINT']}`

export const urlOrdemColeta = `${BASE_URL}/ordem-coleta`

export const urlLocalDescarga = `${BASE_URL}/local-descarga`

export function urlGetOrdensColeta(tp_id, operationcenter_ids, pInicial, pFinal) {
  return `${BASE_URL}/ordem-coleta?tp_id=${tp_id}&operationcenter_ids=${operationcenter_ids}&pInicial=${parseToMysqlFormat(pInicial)}&pFinal=${parseToMysqlFormat(pFinal)}`
}

export function urlGetDevolucaoParcialPendentes(tp_id, company_id, pInicial, pFinal) {
  return `${BASE_URL}/devolucao-parcial-pendentes/${tp_id}/${company_id}?p_inicial=${parseToMysqlFormatWithTime00(pInicial)}&p_final=${parseToMysqlFormatWithTime23(pFinal)}`
}

export function urlGetDevolucaoTotalPendentes(tp_id, company_id, pInicial, pFinal) {
  return `${BASE_URL}/devolucao-total-pendentes/${tp_id}/${company_id}?p_inicial=${parseToMysqlFormatWithTime00(pInicial)}&p_final=${parseToMysqlFormatWithTime23(pFinal)}`
}

export function urlBuscarNotaCliente(invoice_number, delivery_step_id) {
  return `${BASE_URL}/buscar-nota-fiscal-cliente/${invoice_number}/${delivery_step_id}`
}

export const urlAssocNotaFiscalClienteWithDeliveryStep = `${BASE_URL}/assoc-nota-fiscal-cliente-delivery-step`

export const urlNewAssocNotaFiscalClienteWithDeliveryStep = `${BASE_URL}/new-assoc-nota-fiscal-cliente-delivery-step`

export const urlAssociarNotaFiscalClienteComItems = `${BASE_URL}/associar-nota-fiscal-cliente-com-items`

export const urlAssociarDevolucaoParcialOrdemColeta = `${BASE_URL}/associar-devolucao-parcial-ordem-de-coleta`

export const urlAssociarDevolucaoTotalOrdemColeta = `${BASE_URL}/associar-devolucao-total-ordem-de-coleta`

export function urlOcorrenciasPorEntrega(delivery_id) {
  return `${BASE_URL}/ocorrencias-por-entrega/${delivery_id}`
}

export function urlPalletAreaPorEntrega(delivery_id) {
  return `${BASE_URL}/pallet-area-por-entrega/${delivery_id}`
}

export function urlGetMissingProductByDeliveryId(delivery_id) {
  return `${BASE_URL}/missing-product/${delivery_id}`
}

export function urlAtualizarNumNFEntrega(num_nf, delivery_id) {
  return `${BASE_URL}/numero-nf-entrega/${num_nf}/${delivery_id}`
}

export function urlAtualizarSenhaDeColeta(invoice_id, senha) {
  return `${BASE_URL}/senha/${invoice_id}/${senha}`
}

export function urlAtualizarSenhaDeColetaDevolucaoTotal(delivery_id, senha) {
  return `${BASE_URL}/senha-dev-total/${delivery_id}/${senha}`
}

export function urlGetSobrasPendentes(tp_id, company_id, pInicial, pFinal) {
  return `${BASE_URL}/sobras-pendentes/${tp_id}/${company_id}?p_inicial=${parseToMysqlFormatWithTime00(pInicial)}&p_final=${parseToMysqlFormatWithTime23(pFinal)}`
}

export function urlGetSobrasAssociadas(ordemcoleta_id) {
  return `${BASE_URL}/sobras-associadas/${ordemcoleta_id}`
}

export function urlGetClientInvoices(delivery_id) {
  return `${BASE_URL}/client-invoices/${delivery_id}`
}

export function urlGetOcorrenciasAssociadas(ordem_id) {
  return `${BASE_URL}/ocorrencias-associadas/${ordem_id}`
}

export function urlGetLocaisDescarga(operationcenter_id) {
  return `${BASE_URL}/locais-descarga/${operationcenter_id}`
}

export const urlAjustarQuantidadeSobra = `${BASE_URL}/sobras-ajuste-quantidade`

export const urlAssociarSobraComOrdemColeta = `${BASE_URL}/associar-sobras-ordem-de-coleta`

export const urlDesassociarSobraComOrdemColeta = `${BASE_URL}/desassociar-sobras-ordem-de-coleta`

export const urlDesassociarDevolucaoTotalComOrdemColeta = `${BASE_URL}/desassociar-devolucao-total-ordem-de-coleta`

export const urlDesassociarDevolucaoParcialComOrdemColeta = `${BASE_URL}/desassociar-devolucao-parcial-ordem-de-coleta`

export function urlGetDevolucaoTotalAssociadas(ordemcoleta_id) {
  return `${BASE_URL}/devolucao-total-associadas/${ordemcoleta_id}`
}

export function urlGetDevolucaoParcialAssociadas(ordemcoleta_id) {
  return `${BASE_URL}/devolucao-parcial-associadas/${ordemcoleta_id}`
}

export function urlVisualizarOrdemColeta(ordemcoleta_id) {
  return `${BASE_URL}/visualizar-ordem-coleta/${ordemcoleta_id}`
}

export function urlImprimirOrdemColeta(ordemcoleta_id) {
  return `${BASE_URL}/imprimir-ordem-coleta/${ordemcoleta_id}`
}

export function urlGerarExcelOrdemColeta(ordemcoleta_id) {
  return `${BASE_URL}/report-ordem-coleta-excel/${ordemcoleta_id}?t=${localStorage.getItem('t')}`
}

export function urlGerarExcelOrdemColetaAnalitico(ordemcoleta_id) {
  return `${BASE_URL}/report-ordem-coleta-excel-analitico/${ordemcoleta_id}?t=${localStorage.getItem('t')}`
}

export function urlFinalizarOrdemColeta(ordemcoleta_id) {
  return `${BASE_URL}/finalizar-ordem-coleta/${ordemcoleta_id}`
}

export function urlColetarOrdemColeta(ordemcoleta_id) {
  return `${BASE_URL}/coletar-ordem-coleta/${ordemcoleta_id}`
}

export function buildOrdemColetaReportPath(ordemcoleta_id) {
  return `${BASE_URL}/report-ordem-coleta/${ordemcoleta_id}?t=${localStorage.getItem('t')}`
}

export function buildOrdemColetaReportAnaliticoPath(ordemcoleta_id) {
  return `${BASE_URL}/report-ordem-coleta-analitico/${ordemcoleta_id}?t=${localStorage.getItem('t')}`
}

export function urlApagarOrdemColeta(ordemcoleta_id) {
  return `${BASE_URL}/apagar-ordem-coleta/${ordemcoleta_id}`
}

// ***** Aprovacao Ordem Coleta *****
export function urlGetOrdensColetaParaAprovar(tp_ids, company_ids) {
  const nTpIdsString = tp_ids.join(',')
  const nCompanyIdsString = company_ids.join(',')
  return `${BASE_URL}/ordens-coleta-para-aprovacao?tp_ids=${nTpIdsString}&company_ids=${nCompanyIdsString}`
}

export function urlAprovarOrdemColeta(ordemcoleta_id) {
  return `${BASE_URL}/aprovar-ordem-coleta/${ordemcoleta_id}`
}

export const urlSolicitarCorrecaoOrdemColeta = `${BASE_URL}/corrigir-ordem-coleta`

export function urlDownloadNfDevolucaoTotal(ordemcoleta_id) {
  return `${DOCS_BASE_URL}/zipped-nf-dev-total-files/${ordemcoleta_id}`
}

export function urlDownloadNfDevolucaoParcial(ordemcoleta_id) {
  return `${DOCS_BASE_URL}/zipped-nf-dev-parcial-files/${ordemcoleta_id}`
}

// ****** Análise das Ocorrências ***** //
export const urlGetInfoForAnaliseDasOcorrencias = (
  user_id,
  tp_id,
  company_id,
  p_inicial,
  p_final,
) => {
  return `${BASE_URL}/analise-das-ocorrencias?user_id=${user_id}&tp_id=${tp_id}&company_id=${company_id}&p_inicial=${p_inicial}&p_final=${p_final}`
}

// ****** Ocorrências Por Colaboradores ***** //
export const urlGetOcorrenciaPorColaboradores = (company_id, tp_id, p_inicial, p_final) => {
  return `${BASE_URL}/ocorrencias-por-colaboradores?tp_id=${tp_id}&company_id=${company_id}&p_inicial=${p_inicial}&p_final=${p_final}`
}

// ****** Conferencia Ordem de Coleta ***** //
export const urlcreateConferenciaOrdemColeta = ordem_coleta_id => {
  return `${BASE_URL}/criar-conferencia/${ordem_coleta_id}`
}

export const urlHistoricoConferenciaOrdemColeta = ordem_coleta_id => {
  return `${BASE_URL}/historico-conferencia/${ordem_coleta_id}`
}
